import type { Werklijst } from '../../types/Werklijst'
import { DashboardCard } from '../DashboardCard'
import { KpiButton } from '../KpiButton'

export interface Props {
  werklijst: Werklijst
  onClickTile: (werklijst: Werklijst, kpiColor?: string) => void
  subLabel?: string
}

export const WerklijstTile = ({ werklijst, onClickTile, subLabel }: Props) => {
  const { label, count, red, amber, green } = werklijst

  const onClick = (event: any, kpiColor?: string) => {
    event.stopPropagation()
    onClickTile(werklijst, kpiColor)
  }

  return (
    <DashboardCard
      onClick={() => onClickTile(werklijst)}
      label={label}
      subLabel={subLabel}
      count={count}
      actions={
        <>
          {red > 0 && <KpiButton color={'red'} count={red} onClick={onClick} />}
          {amber > 0 && (
            <KpiButton color={'amber'} count={amber} onClick={onClick} />
          )}
          {green > 0 && (
            <KpiButton color={'green'} count={green} onClick={onClick} />
          )}
        </>
      }
    />
  )
}
